'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'holly-berry';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f7aa';
var svgPathData = 'M256.2 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM46.8 343.6l49.4-16.5c.6-32.7 1-58.7 1.4-78 18.8 2.8 45 6.7 78.6 11.7 31.1-14.3 57.8-26.6 80-36.8-4.4 24.1-9.8 52.9-16 86.6 14.4 34.4 22.2 53 23.3 55.8 1.2-2.8 9-21.4 23.3-55.8-6.2-33.7-11.6-62.5-16-86.6 22.2 10.2 48.9 22.5 80 36.8 33.6-5 59.8-8.9 78.6-11.7 .3 19.3 .8 45.3 1.4 78 36 12 62.7 20.9 80 26.7-8.5 17.5-19.8 40.6-33.8 69.3 7 34.9 12.9 64.5 17.8 88.9-22.5-10.7-49.7-23.8-81.8-39.1-31.1 6.5-56.3 11.7-75.5 15.7-.7-19.2-1.6-45.7-2.7-79.7-36.2-11.5-59.9-19-71.3-22.6-11.4 3.6-35.2 11.2-71.3 22.6-1.2 33.9-2.1 60.5-2.7 79.7-19.2-4-44.4-9.2-75.5-15.7-32.1 15.3-59.3 28.4-81.8 39.1 4.9-24.4 10.8-54 17.8-88.9-14-28.8-25.3-51.9-33.8-69.3l30.6-10.2zm81.4-15.9l-.4 22.6c-10.3 3.4-32.6 10.9-66.8 22.3 14 28.8 21.5 44.2 22.5 46.2-.9 4.5-3.3 16.7-7.3 36.7 18.4-8.8 29.7-14.2 33.8-16.2 2.4 .5 18.7 3.9 48.9 10.1 1.1-31 1.8-52.4 2.2-64.3 10.4-3.3 32.7-10.4 66.9-21.2-13.7-32.7-20.7-49.3-20.9-49.8 .6-3.5 2.8-15.3 6.5-35.3-18.5 8.5-29.4 13.5-32.6 15l-9.4-1.4-42.6-6.3-.7 41.5zm270.7 0l-.7-41.5-42.6 6.3-9.4 1.4c-3.2-1.5-14.1-6.5-32.6-15 3.7 20 5.9 31.8 6.5 35.3-.2 .5-7.2 17.1-20.9 49.8 34.2 10.8 56.5 17.9 66.9 21.2 .4 11.9 1.1 33.3 2.2 64.3 30.2-6.3 46.5-9.6 48.9-10.1 4.1 2 15.4 7.3 33.8 16.2-4-20-6.5-32.3-7.3-36.7 1-2 8.5-17.4 22.5-46.2-34.2-11.4-56.5-18.8-66.8-22.3l-.4-22.6zM112.2 144c0-30.4 21.2-55.8 49.6-62.4 2 10.9 5.9 21.2 11.3 30.5-16.2 1.5-28.9 15.2-28.9 31.9 0 17.7 14.3 32 32 32 16.6 0 30.3-12.7 31.9-28.9 9.3 5.4 19.6 9.3 30.5 11.3-6.5 28.4-32 49.6-62.4 49.6-35.3 0-64-28.7-64-64zm224 64c-30.4 0-55.8-21.2-62.4-49.6 10.9-2 21.2-5.9 30.5-11.3 1.5 16.2 15.2 28.9 31.9 28.9 17.7 0 32-14.3 32-32 0-16.6-12.7-30.3-28.9-31.9 5.4-9.3 9.3-19.6 11.3-30.5 28.4 6.5 49.6 32 49.6 62.4 0 35.3-28.7 64-64 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHollyBerry = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;